import StandingDataTabs from './StandingDataTabs';
export default StandingDataTabs;
export { StandingDataTitle } from './StandingDataTitle';
